module.exports = __webpack_public_path__ + "img/img-7.15fe9305.svg";